// extracted by mini-css-extract-plugin
export var body = "_bt-0";
export var sectionHeader = "_bt-4";
export var shortcutColumns = "_bt-2";
export var shortcutList = "_bt-1";
export var shortcutSection = "_bt-3";